"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.function.name.js");
var _index = _interopRequireDefault(require("./src/index.vue"));
var _ConditionNode = _interopRequireDefault(require("./src/components/ConditionNode.vue"));
var _EndNode = _interopRequireDefault(require("./src/components/EndNode.vue"));
var _Node = _interopRequireDefault(require("./src/components/Node.vue"));
var _NormalNode = _interopRequireDefault(require("./src/components/NormalNode.vue"));
var _StartNode = _interopRequireDefault(require("./src/components/StartNode.vue"));
var _NodeContent = _interopRequireDefault(require("./src/components/NodeContent.vue"));
var _NodeTypeContent = _interopRequireDefault(require("./src/components/NodeTypeContent.vue"));
var _DeleteNode = _interopRequireDefault(require("./src/components/DeleteNode.vue"));
var install = function install(Vue) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    notRegisterNodeContent = _ref.notRegisterNodeContent,
    notRegisterNodeTypeContent = _ref.notRegisterNodeTypeContent;
  Vue.component(_ConditionNode.default.name, _ConditionNode.default);
  Vue.component(_EndNode.default.name, _EndNode.default);
  Vue.component(_Node.default.name, _Node.default);
  Vue.component(_NormalNode.default.name, _NormalNode.default);
  Vue.component(_StartNode.default.name, _StartNode.default);
  Vue.component(_DeleteNode.default.name, _DeleteNode.default);
  Vue.component(_index.default.name, _index.default);
  if (!notRegisterNodeContent) {
    Vue.component(_NodeContent.default.name, _NodeContent.default);
  }
  if (!notRegisterNodeTypeContent) {
    Vue.component(_NodeTypeContent.default.name, _NodeTypeContent.default);
  }
};
var _default = exports.default = {
  install: install
};